module.exports = "<div class=\"panel-heading\">\n    <div class=\"panel-title\">\n        <p class=\"m-b-20 section-title m-t-20\">{{ 'Address' | translate }}</p>\n    </div>\n</div>\n<chassis-form [form]=\"form\" class=\"form-horizontal\"></chassis-form>"


//////////////////
// WEBPACK FOOTER
// ./libs/donna-core/src/app/addresses/components/address-form/address-form.component.html
// module id = ./libs/donna-core/src/app/addresses/components/address-form/address-form.component.html
// module chunks = main